// extracted by mini-css-extract-plugin
export default {"inputCaption":"P+PrIa3plWuCp5SfmcURFw=="};